import { FunctionComponent } from "react";
import Checkbox from "rivals/components/shared/Form/Checkbox";
import styles from "./SubscriptionAgreement.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const SubscriptionAgreement: FunctionComponent<OwnProps> = ({
  isAutoRenewAgreed,
  onAutoRenewChange,
  title
}) => {
  const { autoRenewalOptIn, requiredSubscriptionAgreement } = strings;
  return (
    <div className={styles.subscriptionAgreement}>
      <div className={styles.subscriptionTitle}>
        {title || requiredSubscriptionAgreement}
      </div>
      <Checkbox
        className={styles.autoOptInAgree}
        data="subscriptions-new-auto-opt-in-agree"
        isChecked={isAutoRenewAgreed}
        label={autoRenewalOptIn}
        onChange={(): void => {
          onAutoRenewChange(!isAutoRenewAgreed);
        }}
      />
    </div>
  );
};

export default SubscriptionAgreement;
